export enum ContrastTestRating {
    SSE = 'sehr stark eingeschränkt',
    SE = 'sehr eingeschränkt',
    ME = 'mittelgradig eingeschränkt',
    GE = 'gering eingeschränkt',
    NE = 'nicht eingeschränkt'
}

export interface ContrastTestObject {
    percentage: number;
    rating: ContrastTestRating;
    seen: number;
    correctGuess: number;
    wrongGuess: number;
    identified: boolean;    // if testing person identifies two out of three rings from one size, set this to true
    identifiedCorrectly: boolean;
    identifiedWrongly: boolean;
}

export type ContrastTestData = ContrastTestObject[];

const common = {
    seen: 0,
    correctGuess: 0,
    wrongGuess: 0,
    identified: false,
    identifiedCorrectly: false,
    identifiedWrongly: false
};

export const contrastTestData: ContrastTestData = [
    { percentage: 80, rating: ContrastTestRating.SSE, ...common },
    { percentage: 63, rating: ContrastTestRating.SSE, ...common },
    { percentage: 50, rating: ContrastTestRating.SSE, ...common },
    { percentage: 40, rating: ContrastTestRating.SSE, ...common },
    { percentage: 32, rating: ContrastTestRating.SSE, ...common },
    { percentage: 25, rating: ContrastTestRating.SSE, ...common },
    { percentage: 20, rating: ContrastTestRating.SSE, ...common },
    { percentage: 16, rating: ContrastTestRating.SSE, ...common },
    { percentage: 12, rating: ContrastTestRating.SE, ...common },
    { percentage: 10, rating: ContrastTestRating.SE, ...common },
    { percentage: 8, rating: ContrastTestRating.SE, ...common },
    { percentage: 6.3, rating: ContrastTestRating.ME, ...common },
    { percentage: 5, rating: ContrastTestRating.ME, ...common },
    { percentage: 4, rating: ContrastTestRating.ME, ...common },
    { percentage: 3.2, rating: ContrastTestRating.GE, ...common },
    { percentage: 2.5, rating: ContrastTestRating.GE, ...common },
    { percentage: 2, rating: ContrastTestRating.GE, ...common },
    { percentage: 1.5, rating: ContrastTestRating.NE, ...common },
    { percentage: 1, rating: ContrastTestRating.NE, ...common },
    { percentage: 0.5, rating: ContrastTestRating.NE, ...common }
];

export function resetContrastData(): void {
    for (const data of contrastTestData) {
        data.seen = 0;
        data.correctGuess = 0;
        data.wrongGuess = 0;
        data.identified = false;
        data.identifiedCorrectly = false;
        data.identifiedWrongly = false;
    }
}
